// extracted by mini-css-extract-plugin
export default {"title":"Titile_title__T6KXo"};